var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AutocompleteField',{attrs:{"value":_vm.value,"items":_vm.statuses,"label":_vm.label,"item-text":"1","item-value":"0"},on:{"input":_vm.emitChange}})}
var staticRenderFns = []

export { render, staticRenderFns }